import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ServerError.module.scss';

export const ServerError = () => {
  const { t } = useTranslation('error');

  const title = t('error:serverError.title');
  const message = t('error:serverError.message');
  const actionText = t('error:serverError.actionText');

  return (
    <div className={styles.container} data-testid="server-error">
      <img
        className={styles.img}
        src="/app/static/images/errors/error-500.png"
        alt="Error 500"
      />
      <h1 className={styles.title}>
        {title}
        <br />
        {message}
        <br />
        {actionText}
      </h1>
    </div>
  );
};
